import React, { Component } from 'react';
import radioLogo from '../public/sotherly-radio.png';
import headerText from '../public/header-text.png';
import subText from '../public/sub-text.png';
import './App.css';
import Player from './Player';

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="content">
          <img className="sotherly-radio" src={ radioLogo } alt="Sotherly Radio" />
          <img className="header-text" src={ headerText } alt="Sothely Radio Text" />
          <img className="sub-text" src={ subText } alt="Sothely Radio Text" />
        </div>
        <Player />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js